import { isEmpty } from 'lodash'

import { usersReportingFromServer } from 'utils/data-change-requests'
import { removeEmpty } from 'utils/objects'

import { companyDataFromServer } from './company-model'

// camelCase working shape from dataChangeRequestFromServer (adds derived customerName/userName/numberOfReports); data/meta/usersReporting stay loose (arbitrary payloads / parsed JSON / transformed list).
export type DataChangeRequestRow = {
  id: number
  uuid: string
  status: string
  type: string
  data: any
  meta: any
  customerId: number
  customerName: string
  userId: number
  userName: string
  numberOfReports: number
  usersReporting: any
  createdAt: string
  updatedAt: string
}

export const dataChangeRequestFromServer = (x): DataChangeRequestRow =>
  x
    ? {
        id: x.id,
        uuid: x.company_uuid,
        status: x.status,
        type: x.type,
        data: normalizeData(x.data),
        meta: parseMeta(x.meta),
        customerId: x.customer_id,
        customerName: x.customer ? x.customer.name : '',
        userId: x.user_id,
        userName: x.user ? `${x.user.first_name} ${x.user.last_name}` : '',
        numberOfReports: x.number_of_reports,
        usersReporting: usersReportingFromServer(x.users_reporting),
        createdAt: x.created_at,
        updatedAt: x.updated_at,
      }
    : // Defensive empty (x absent) — consumers gate on loading/enabled before reading.
      ({} as DataChangeRequestRow)

const parseMeta = meta => {
  if (!meta) return null
  if (typeof meta === 'string') {
    try {
      return JSON.parse(meta)
    } catch {
      return null
    }
  }
  return meta
}

const normalizeData = data => ({
  ...data,
  employees: isEmpty(data?.employees) ? undefined : data.employees,
})

// Build the list query; `|| undefined` drops empty filters so they aren't sent as blank params.
export const getDataChangeRequestQuery = meta => ({
  limit: meta.rowsPerPage,
  offset: meta.page * meta.rowsPerPage,
  statuses: meta.filters?.status || undefined,
  type: meta.filters?.type || undefined,
  search: meta.filters?.search || undefined,
  sort_by: meta.sortBy || undefined,
  sort_order: meta.sortOrder || undefined,
})

export const getDataChangeRequestDiff = x => removeEmpty(companyDataFromServer(x))
